import type { Marker } from '@googlemaps/markerclusterer';

export type SlabMapMarkerClusterMeta = {
  locationType: string;
  color: string;
};

const META_KEY = '__slabClusterMeta';

type MarkerWithMeta = google.maps.marker.AdvancedMarkerElement & {
  [META_KEY]?: SlabMapMarkerClusterMeta;
};

export const setSlabMapMarkerClusterMeta = (
  marker: google.maps.marker.AdvancedMarkerElement,
  meta: SlabMapMarkerClusterMeta,
): void => {
  (marker as MarkerWithMeta)[META_KEY] = meta;
};

export const getSlabMapMarkerClusterMeta = (marker: Marker): SlabMapMarkerClusterMeta | undefined =>
  (marker as MarkerWithMeta)[META_KEY];
